import { render, staticRenderFns } from "./PatchScoreTableElementComponent.vue?vue&type=template&id=ddb22904&"
import script from "./PatchScoreTableElementComponent.vue?vue&type=script&lang=ts&"
export * from "./PatchScoreTableElementComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddb22904')) {
      api.createRecord('ddb22904', component.options)
    } else {
      api.reload('ddb22904', component.options)
    }
    module.hot.accept("./PatchScoreTableElementComponent.vue?vue&type=template&id=ddb22904&", function () {
      api.rerender('ddb22904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/Elements/PatchScoreTableElementComponent.vue"
export default component.exports